import React from 'react';

import { Box, makeStyles } from '@material-ui/core';
import { ChangeLog } from 'types';
import { fonts } from 'theme';
import { formatDateForDisplay } from 'utils/date';

const useStyles = makeStyles({
  logRow: {
    display: 'flex',
    whiteSpace: 'pre-wrap',
    flexDirection: 'row',
    fontFamily: fonts.secondary,
    '&:first-child': {
      marginBottom: '7px',
    },
    '&:nth-child(2n)': {
      marginBottom: '30px',
    },
    '& > div': {
      marginRight: '10px',
      '&:first-child': {
        fontWeight: 700,
      },
    },
  },
});

interface VersioningPageProps {
  changelogs: ChangeLog[] | undefined;
}

const VersioningPage: React.FC<VersioningPageProps> = ({ changelogs }) => {
  const classes = useStyles();

  return (
    <Box py={5} px={3} maxWidth="80%">
      {changelogs?.map(changeLog => {
        return (
          <>
            <Box className={classes.logRow} key={`${changeLog.version}_version`}>
              <Box>{changeLog.version}</Box>
              <Box>-</Box>
              <Box>{formatDateForDisplay(changeLog.releaseDate)}</Box>
            </Box>
            <Box className={classes.logRow} key={`${changeLog.version}_content`}>
              {changeLog.content}
            </Box>
          </>
        );
      })}
    </Box>
  );
};
export default VersioningPage;
